
<template>
  <!--住户认证记录-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="householderApplyId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :rowSelection="false"
      @resetSearch = "resetSearch"
    >
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'householdAuthRecord',
  data () {
    return {
      searchList: [
        {
          props: ['areas'],
          placeholder: '省市',
          options: [],
          inputType: 'cascader',
          changeOnSelect: true,
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(0, 'searchList', '1,2,3', e);
          }
        },
        { props: ['communityId'], placeholder: '小区', options: [], inputType: 'select', fetchOptions: this.getOptions },
        { props: ['keywords'], placeholder: '手机号、房间号', options: [], inputType: 'input' },
        { props: ['householdType'], placeholder: '认证类型', options: [], inputType: 'select' },
        { props: ['authResource'], placeholder: '认证方式', options: [], inputType: 'select' },
        { props: ['status'], placeholder: '审核状态', options: [], inputType: 'select' },
        { props: ['propertyId'], placeholder: '物业', options: [], inputType: 'select' },
        { props: ['createDate'], placeholder: ['提交时间', '提交时间'], options: [], inputType: 'datePick' },
        { props: ['checkDate'], placeholder: ['审核时间', '审核时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [],
      rowOptList: [
        {text: '审核', handle: row => this.toDetail(row), permi: ['community:householder:apply:verify']}
      ],
      columns: [
        { title: '手机号', dataIndex: 'mobile', align: 'left', width: '' },
        { title: '认证类型', dataIndex: 'householdTypeDesc', align: 'left', width: '' },
        { title: '申请房间', dataIndex: 'roomAddress', align: 'left', width: '' },
        { title: '提交时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '认证方式', dataIndex: 'authResourceDesc', align: 'left', width: '' },
        { title: '审核状态', dataIndex: 'verifyStatusDesc', align: 'left', width: '' },
        { title: '审核人', dataIndex: 'checkUserName', align: 'left', width: '' },
        { title: '审核时间', dataIndex: 'checkTime', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        communityId: undefined,
        keywords: undefined,
        householdType: undefined,
        authResource: undefined,
        status: undefined,
        areas: undefined,
        propertyId: undefined,
        createDate: undefined,
        checkDate: undefined
      },
      listApi: {
        url: '/householderApply/list',
        resHandle: '',
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'householdAuthRecordDetail',
        title: ''
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    resetSearch () {
      this.communitySelectByStep(undefined, undefined, 'searchList', '1');
      this.searchList[1].searchValue = undefined;
    },
    /* 获取下拉 */
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, 'searchList', '1');
    },
    getSelect () {
      this.regionSelect(0);
      this.propertySelect(6);
      // this.communitySelect(1, 'searchList', 1);
      this.communitySelectByStep(1, undefined, 'searchList', '1');

      let paramArr = [
        {index: 3, scope: 'searchList', query: 'comu_household_type'},
        {index: 4, scope: 'searchList', query: 'comu_householder_apply_type'},
        {index: 5, scope: 'searchList', query: 'comu_verify_type'}
      ];
      this.dictionarySelect(paramArr);
    },
    /** 进入审核详情 */
    toDetail (row) {
      this.$router.push({
        name: 'householdAuthRecordDetail',
        query: {
          title: row.status === 0 ? '住户认证记录审核' : '住户认证记录详情',
          status: `${row.status}`,
          id: row.householderApplyId,
          ...this.breadParam(this)
        }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
